import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Ad from '@ifeng/ui_pc_ad';
import QuickSelect from './quickSelect';
import HotSale from './hotSale';
import Title from '../../../components/title';
import SubTitle from '../../../components/subtitle';

class SelectCar extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        curCity: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content, curCity } = this.props;

        return (
            <div className={styles.s_div}>
                <Title content="选车" />
                <div>
                    <div className={styles.sq}>
                        <div className={styles.select_title}>
                            <SubTitle content={{ title: '快捷选车' }} />
                        </div>

                        <QuickSelect />
                    </div>
                    <div className={styles.sr}>
                        <SubTitle content={{ title: '热销榜' }} />
                        <HotSale curCity={curCity} />
                    </div>
                </div>
            </div>
        );
    }
}

export default SelectCar;
